import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

import { DomainError, type DomainErrorKind } from '@domain/errors/domain.error';

function mapStatusToKind(status: number): DomainErrorKind {
  if (status === 0) return 'network';
  if (status === 401) return 'unauthorized';
  if (status === 403) return 'forbidden';
  if (status === 404) return 'not-found';
  if (status === 409) return 'conflict';
  if (status >= 400 && status < 500) return 'validation';
  return 'unknown';
}

export const errorInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof DomainError) {
        return throwError(() => error);
      }

      if (error instanceof HttpErrorResponse) {
        let message =
          typeof error.error?.message === 'string'
            ? error.error.message
            : error.message || 'Request failed.';

        if (error.status === 0) {
          message =
            'Cannot reach the API (network/CORS). Check apiBaseUrl uses https://api.dev.ksap.app and that you are online.';
        } else if (error.status === 401) {
          message = 'Unauthorized — check your email and password.';
        } else if (error.status === 500 && req.url.toLowerCase().includes('sign-in')) {
          message = 'Login failed — email/password combination is not correct.';
        }

        return throwError(
          () => new DomainError(mapStatusToKind(error.status), message, {}, error),
        );
      }

      return throwError(() => DomainError.unknown(error));
    }),
  );
